import { getLocale } from '@arnold/core';
import { format } from 'date-fns';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ReactComponent as ClosedChat } from '../assets/images/ClosedChat.svg';
import { ReactComponent as NewChat } from '../assets/images/NewChat.svg';
import { ReactComponent as UnfinishedChat } from '../assets/images/UnfinishedChat.svg';
import { IChannel, IUserChannel } from '../types';
import Banner from './Banner';
import { Button } from './Button';

interface IProps {
  channel: IChannel | IUserChannel;
}

const ChannelBanner = ({ channel }: IProps) => {
  const { t } = useTranslation('channelBanner');
  const isNew = !channel.isOpen && !channel.isFinished;
  const isOpened = channel.isOpen && !channel.isFinished;
  const isClosed = channel.isFinished;
  const translationPrefix = isNew ? 'new' : isOpened ? 'opened' : 'closed';

  return (
    <Banner
      image={
        <>
          {isNew && <NewChat width={'176px'} />}
          {isOpened && <UnfinishedChat width={'176px'} />}
          {isClosed && <ClosedChat width={'176px'} />}
        </>
      }
      text={
        <>
          <h2>{t(translationPrefix + '_header')}</h2>
          <p>
            {t(translationPrefix + '_text_1')}
            <strong>{channel.topicName}</strong>
            {t(translationPrefix + '_text_2')}
            <strong>{t(translationPrefix + '_text_3', { defaultValue: '' })}</strong>
            {t(translationPrefix + '_text_4', { defaultValue: '' })}
            <strong>
              {format(new Date(channel.endsAt), 'HH:mm, eeee, d. MMMM.', { locale: getLocale(i18n.language) })}
            </strong>
            {t(translationPrefix + '_text_5')}
          </p>
          <Link to={isClosed ? `/chat-overview/${channel.id}` : `/${channel.id}`}>
            <Button data-icom={`banner-${translationPrefix}-button`}>{t(translationPrefix + '_button')}</Button>
          </Link>
        </>
      }
      dataIcom={`channel-banner-${translationPrefix}`}
    />
  );
};

export default ChannelBanner;
